module.exports = __webpack_public_path__ + "media/images/missing_avatar-d6a64ff8e98266a3efa5668c122d0766.jpg";